import * as THREE from 'three'

export interface BackgroundOptions {
  $canvas: HTMLCanvasElement
  backgroundColor: THREE.ColorRepresentation
}

const NotImplError = new Error('not impl')

interface ThreeComponetUniforms {
  [uniform: string]: THREE.IUniform<any>
}

export class ThreeComponet<Uni extends ThreeComponetUniforms> {
  obj!: THREE.Object3D

  constructor(public uniforms: Uni, inited: boolean = true) {
    if (inited) {
      this.obj = this.createObj()
    }
  }

  createObj(): THREE.Object3D {
    throw NotImplError
  }

  render(time: number): void {}
  resize(): void {}
}
